import Controller from "../Engine/Controller";
import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";

class Link extends Controller {

    constructor(dom, options) {
        super(dom, "Link");

        this._buttonListener = null;

        if (options) {
            this.uri = options.uri ? options.uri : "";
            this.canSendRequestToServer = true;

            if (options.serverlistener)
                this.serverListener(options.serverlistener, options);

            if (options.clientlistener)
                this.clientlistener(options.clientlistener);
        }
    }
    /*
    * get true uri by server listener key
    */
    _getUriRequest(key) {
        if (key.indexOf("http:")>-1 || key.indexOf("https:")>-1 || key[0]==="/")
            return key;

        return "ajax-"+key;
    }
    /*
    * create server listener from usual button
    */
    serverListener(key, options) {
        let that = this;

        function _sendRequestToServer(form) {
            Engine.postRequest(
                that.uri ? that.uri+"ajax-"+key : that._getUriRequest(key), {},
                function (response) {
                    that._enabledServerSend();

                    Engine.parseRequestAnswer(response);
                }
            );
        }

        this._buttonListener = cfJS.addListener(this.domNode, "click", function (e) {
            if (!that.canSendRequestToServer)
                return;

            if (options.confirm)
            {
                let isConfirm = confirm(that.domNode.getAttribute("confirm-phrase"));

                if (!isConfirm) {
                    e.preventDefault();
                    return false;
                }
            }

            _sendRequestToServer();
            that._disabledServerSend();
            e.preventDefault();
            return false;
        });
    }
    /*
    *
    */
    _enabledServerSend() {
        this.canSendRequestToServer = true;
       // this.domNode.removeAttribute("wait-answer","");
    }
    /*
    *
    */
    _disabledServerSend() {
        this.canSendRequestToServer = false;
        //this.domNode.setAttribute("wait-answer","");
    }
    /*
    * call client trigger
    */
    clientlistener(key) {
        this._buttonListener = cfJS.addListener(this.domNode, "click", function (e) {
            window[key](this,e);
            e.preventDefault();
            return false;
        });
    }

}

window.Link = Link;